import { render, staticRenderFns } from "./OldOak.vue?vue&type=template&id=076acd58&scoped=true&"
import script from "./OldOak.vue?vue&type=script&lang=js&"
export * from "./OldOak.vue?vue&type=script&lang=js&"
import style0 from "./OldOak.vue?vue&type=style&index=0&id=076acd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076acd58",
  null
  
)

export default component.exports